'use strict';

var React = require('react'),
    AnchorScrollMixin = require('./AnchorScrollMixin'),
    { isMobile } = require('../utils/Browser');

/**
 * Listens to `keydown` and `keyup` events and provides snapping
 * on space press.
 */
var StampScrollMixin = {
  mixins: [AnchorScrollMixin],

  propTypes: {
    isInViewer: React.PropTypes.bool.isRequired
  },

  componentDidMount: function () {
    if (isMobile()) {
      return;
    }

    window.addEventListener('keydown', this._handleKeyDown);
    window.addEventListener('keyup', this._handleKeyUp);
  },

  componentWillUnmount: function () {
    if (isMobile()) {
      return;
    }

    window.removeEventListener('keydown', this._handleKeyDown);
    window.removeEventListener('keyup', this._handleKeyUp);
  },

  _handleKeyDown: function (e) {
    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
      return;
    }

    this.handleSpaceKeyDown(e);
  },

  _handleKeyUp: function (e) {
    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
      return;
    }

    this.handleSpaceKeyUp(e);
  }
};

module.exports = StampScrollMixin;


/** WEBPACK FOOTER **
 ** ./mixins/StampScrollMixin.js
 **/